import { lifecycle, compose, withState } from 'recompose';
import { connect } from 'react-redux';

import EmptyList from './EmptyList';
import StaffList from './StaffList';
import withLoadingList from '../../../common/hoc/withLoaingList';
import { fetchStaffMembers } from '../actions';
import withOwnerTypeAndId from '../../../common/hoc/withOwnerTypeAndId';

export default compose(
  withOwnerTypeAndId,
  connect(null, { fetchStaffMembers }),
  withState('staffMembers', 'setStaffMembers', []),
  lifecycle({
    componentWillMount() {
      this.props.fetchStaffMembers(this.props.ownerType, this.props.ownerId).then((staffMembers) => {
        this.props.setStaffMembers(staffMembers);
      });
    },
  }),
  withLoadingList(
    props => props.staffMembers,
    EmptyList,
  )
)(StaffList);
